import { Box } from '@mui/material'
import { FieldValues, UseFormHandleSubmit } from 'react-hook-form'

interface MainContainerProps<T extends FieldValues> {
  children: React.ReactNode
  handleSubmit: UseFormHandleSubmit<T>
  onSubmit: () => void
}

const MainContainer = <T extends FieldValues>(
  props: MainContainerProps<T>,
) => {
  const { children, handleSubmit, onSubmit } = props
  return (
    <Box
      component='form'
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%',
        margin: '1.3rem 0 0 0',
      }}
    >
      {children}
    </Box>
  )
}

export default MainContainer
